import React from 'react';
import * as Styled from './Layout.styled';
import { StyledBackgroundContainer } from '../StyledBackgroundContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
// @deprecated added per CL-39568, clean up with CL-40328
const versionCheck = (minHeightPreset, schemaVersion = 2.0) => {
  if (schemaVersion <= 2.0) {
    /** old LAYOUT_MIN_HEIGHT_PRESETS = XS: 216px | S: 340px | M: 480px | L: 620px  */
    const oldMinHeightPreset = {
      XS: 'S',
      S: 'M',
      M: 'L',
      L: 'XL',
      XL: 'XL'
    };
    return oldMinHeightPreset[minHeightPreset];
  }
  return minHeightPreset;
};

/**
 * The `Layout` container is a "row" in the overall page layout.  A `Layout` block
 * can only be the child of a `Canvas` block and it can contain 1 - 3 `Section`
 * blocks as children.
 */
export const Layout = ({
  cssBackgroundColor,
  cssBackgroundColorOpacity,
  cssBackgroundImageOpacity,
  cssBackgroundPosition,
  backgroundImagePreset,
  backgroundImageUrl,
  cssBorderColor,
  cssBorderWidth,
  cssBorderStyle,
  minHeightPreset,
  layoutBlockInfo,
  schemaVersion,
  children,
  ...rest
}) => /*#__PURE__*/_jsx(StyledBackgroundContainer, {
  cssBackgroundColor: cssBackgroundColor,
  cssBackgroundColorOpacity: cssBackgroundColorOpacity,
  cssBackgroundImageOpacity: cssBackgroundImageOpacity,
  cssBackgroundPosition: cssBackgroundPosition,
  backgroundImageUrl: backgroundImageUrl,
  backgroundImagePreset: backgroundImagePreset,
  zIndex: layoutBlockInfo?.zIndex,
  children: /*#__PURE__*/_jsx(Styled.LayoutContent, {
    cssBorderWidth: cssBorderWidth,
    cssBorderColor: cssBorderColor,
    cssBorderStyle: cssBorderStyle
    // TODO added version check per CL-39568, clean up with CL-40328
    ,
    minHeightPreset: versionCheck(minHeightPreset, schemaVersion),
    layoutBlockInfo: layoutBlockInfo,
    ...rest,
    children: children
  })
});